import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import DownPaymentInput from '../down-payment';

const DownPaymentInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <DownPaymentInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default DownPaymentInputWithAnalytics;
